import React, { useState, Fragment, useEffect } from 'react';
import { Input } from '@vds/inputs';
import { ButtonGroup } from '@vds/buttons';
import { Title, Body, Micro } from '@vds/typography';
import { Row, Col, Grid } from '@vds/grids';
import { Line } from '@vds/lines';
import * as SiteAnalytics from '../../sitecatalyst';
import './fiosRegistrationPage.css';

const validation = {
	firstName: { regex: /^[a-zA-Z]+$/, errorMessage: 'Invalid firstname', required: true },
	lastName: { regex: /^[A-Za-z]+$/, errorMessage: 'Invalid lastname', required: true },
	email: {
		regex: /^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9-]+\.+[a-zA-Z0-9\.]{2,6}$/,
		errorMessage: 'Invalid email',
		required: true
	},
	zipCode: { regex: /^[1-9]\d{4}$/, errorMessage: 'Invalid ZIP code', required: true },
	mobileNum: { regex: /^[1-9]\d{9}$/, errorMessage: 'Invalid mobile number' },
	businessNum: { regex: /^[1-9]\d{9}$/, errorMessage: 'Invalid business number' },
	streetAddress: { required: true },
	city: { required: true },
	checkBox: { required: true }
}

const FiosRegistrationPage = () => {
	const [state, _setState] = useState({
		firstName: '',
		lastName: '',
		email: '',
		zipCode: '',
		mobileNum: '',
		businessNum: '',
		city: '',
		unit: '',
		streetAddress: '',
		checkBox: ''
	})
	const [endInteraction, setEndInteraction] = useState(false);

	const [error, setError] = useState({})

	useEffect(() => {
		SiteAnalytics.trackPageInfo();
		setEndInteraction(true);
	}, []);

    useEffect(() => {
        if(endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            setEndInteraction(false);
        }
    });
	
	function setState(field, value) {
		switch (field) {
			case 'firstName': {
				const regex = /^[a-zA-Z]+$/
				if (!regex.test(value) && value !== '') {
					return
				}
				break
			}
			case 'lastName': {
				const regex = /^[A-Za-z]+$/
				if (!regex.test(value) && value !== '') {
					return
				}
				break
			}

			case 'zipCode': {
				var regex = /^\d{0,5}$/
				if (!regex.test(value)) {
					return
				}
				break
			}
			case 'mobileNum': {
				const regex = /^[1-9]\d*\.?\d*$/
				if (!regex.test(value) && value !== '') {
					return
				}
				break
			}
			case 'businessNum': {
				const regex = /^[1-9]\d*\.?\d*$/
				if (!regex.test(value) && value !== '') {
					return
				}
				break
			}
			case 'checkBox':
			case 'email':
			case 'city':
			case 'streetAddress':
			case 'unit':
				break

			default:
			//
		}

		_setState((state) => ({
			...state,
			[field]: value
		}))
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		const errors = {}
		const fields = Object.keys(state)
		//console.log('fieldsss' + fields)

		// debugger

		for (let i = 0; i < fields?.length; i++) {
			const key = fields[i]
			const value = state[fields[i]]

			const { regex, errorMessage, required } = validation[key] || {}

			if (regex && value) {
				// regex available
				const result = regex.test(value)
				if (!result) {
					errors[key] = errorMessage
				}
				continue
			}

			if (!value && required) {
				errors[key] = 'Required field'
			}
		}

		const errorKeys = Object.keys(errors)

		console.log(errors)
		if (errorKeys?.length > 0) {
			// errors were found
			setError(errors)
			return
		}

		alert('No errors')
	}

	return (
		<Fragment>
			<form onSubmit={handleSubmit} novalidate={true}>

				<Grid className="Fios-Registration-Page" colSizes={{ "mobile": 4, "desktop": 12, "tablet": 12 }} colGutter={false} rowGutter='1.4rem'>
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 10, "tablet": 10 }}>
							<div className="Registration-Page-Title">
								<Title size="medium" primitive="h1">
									Let me know when Fios Internet is available
      						</Title>
							</div>
						</Col>
						<Col colSizes={{ "mobile": 4, "desktop": 2, "tablet": 2 }}>
							<div className="Required-fields">
								<Body size="medium" color="gray" primitive="h2">
									<span className="star">*</span>{" "}Required fields
      						</Body>
							</div>
						</Col>
						<Line type="xLight" noMargin />
					</Row>
					<Row>

					</Row>
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								<span className="star">*</span> First Name
      						</Micro>
							<Input
								type="text"
								placeholder="First Name"
								className="input-box"
								value={state.firstName}
								required={false}
								width={"98%"}
								error={!!error['firstName']}
								errorText={error['firstName']}
								onChange={(e) => setState('firstName', e.target.value)}
							/>
						</Col>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								<span className="star">*</span> Last Name
      						</Micro>
							<Input
								type="text" Last Name
								placeholder="Last Name"
								value={state.lastName}
								error={!!error['lastName']}
								errorText={error['lastName']}
								className="input-box"
								required={false}
								width={"98%"}
								// required
								onChange={(e) => setState('lastName', e.target.value)}
							/>
						</Col>
					</Row>
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								<span className="star">*</span> Email Address
      						</Micro>
							<Input
								width={"98%"}
								type="text"
								className="input-box"
								required={false}
								placeholder="Email Address"
								error={!!error['email']}
								errorText={error['email']}
								value={state.email}
								onChange={(e) => setState('email', e.target.value)}
							/>
						</Col>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								Mobile Number
      						</Micro>
							<Input
								width={"98%"}
								type="text"
								className="input-box"
								required={false}
								placeholder="XXX-XXX-XXXX"
								value={state.mobileNum}
								error={!!error['mobileNum']}
								errorText={error['mobileNum']}
								onChange={(e) => setState('mobileNum', e.target.value)}
								maxLength={10}
							/>
						</Col>
					</Row>
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								Business Number
      						</Micro>
							<Input
								width={"98%"}
								type="text"
								className="input-box"
								required={false}
								placeholder="XXX-XXX-XXXX"
								value={state.businessNum}
								error={!!error['businessNum']}
								errorText={error['businessNum']}
								onChange={(e) => setState('businessNum', e.target.value)}
								maxLength={10}
							/>
						</Col>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<div className="existing-customer">
								<Input type="checkbox" name="default">
									I am an existing Verizon landline customer
							</Input>
							</div>
						</Col>
					</Row>

					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								<span className="star">*</span> Zip code
      						</Micro>
							<Input
								width="98%"
								type="text"
								className="input-box"
								value={state.zipCode}
								required={false}
								placeholder="Zip"
								maxLength={5}
								// required
								error={!!error['zipCode']}
								errorText={error['zipCode']}
								onChange={(e) => setState('zipCode', e.target.value)}
							/>
						</Col>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								<span className="star">*</span> City
      						</Micro>
							<Input
								width="98%"
								type="text"
								className="input-box"
								placeholder="City"
								required={false}
								// required
								value={state.city}
								error={!!error['city']}
								errorText={error['city']}
								onChange={(e) => setState('city', e.target.value)}
							/>
						</Col>
					</Row>
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								<span className="star">*</span> Street Address
      						</Micro>
							<Input
								width="98%"
								type="text"
								className="input-box"
								required={false}
								placeholder="Street address"
								// required
								error={!!error['streetAddress']}
								errorText={error['streetAddress']}
								value={state.streetAddress}
								onChange={(e) => setState('streetAddress', e.target.value)}
							/>
						</Col>
						<Col colSizes={{ "mobile": 4, "desktop": 6, "tablet": 6 }}>
							<Micro primitive="h2" color="gray">
								Unit #
      						</Micro>
							<Input
								width="98%"
								type="text"
								className="input-box"
								required={false}
								placeholder="unit"
								value={state.unit}
								error={!!error['unit']}
								errorText={error['unit']}
								onChange={(e) => setState('unit', e.target.value)}
							/>
						</Col>
					</Row>
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 12, "tablet": 12 }}>
							<Input
								type="checkbox"
								name="error"
								value={state.checkBox}
								error={!!error['checkBox']}
								errorText={error['checkBox']}
								onChange={(e) => setState('checkBox', e.target.value)}
							>
								<Body size="small" bold primitive="h2"><span className="star">*</span> Notify me when fios Internet is available</Body> <br />
								<Body size="medium" primitive="h2">
									<p>By submitting my request, I agree to receive an automated text message, call and email notifications
										when Fios becomes available in my area, including applicable offers. Message and data rates may
										apply for texts.</p>
								</Body>
							</Input>
						</Col>
					</Row>
					<Line type="xLight" />
					<Row>
						<Col colSizes={{ "mobile": 4, "desktop": 8, "tablet": 8 }}></Col>
						<Col colSizes={{ "mobile": 4, "desktop": 4, "tablet": 4 }}>
							<ButtonGroup
								childWidth={'100%'}
								viewport={'desktop'}
								rowQuantity={{ desktop: 2, mobile: 1 }}
								data={[
									{
										children: 'Close',
										size: 'large',
										buttonType: 'secondary',
										width: '100px',
										// onClick: this.handleClickEvent,
									},
									{
										children: 'Submit',
										size: 'large',
										buttonType: 'primary',
										width: '100px',
										// onClick: this.handleClickEvent,
									},
								]}
							/>
						</Col>
					</Row>
				</Grid>
			</form >

		</Fragment >
	)
}

export default FiosRegistrationPage
